import { styled } from '@mui/material/styles';
import { Box } from '@mui/material';

export const ThumbnailSize = 58;
export const GroupSampleHeight = 130;

export const TreeBranch = styled(Box, {
  shouldForwardProp: property => property !== 'isLastItem',
})<{ isLastItem?: boolean }>(({ theme, isLastItem }) => ({
  width: '20px',
  position: 'relative',
  flexShrink: 0,
  '&::before': {
    content: '""',
    position: 'absolute',
    left: '8px',
    top: '60px',
    width: '12px',
    height: '1px',
    backgroundColor: theme.palette.divider,
  },
  '&::after': {
    content: '""',
    position: 'absolute',
    left: '8px',
    top: 0,
    height: isLastItem ? '60px' : '100%',
    width: '1px',
    backgroundColor: theme.palette.divider,
  },
}));

export const GroupNameContainer = styled(Box)(() => ({
  display: 'flex',
  alignItems: 'center',
  gap: '4px',
  marginBottom: '4px',
  minWidth: 0,
  '& .edit-icon, & .menu-icon': {
    opacity: 0,
    transition: 'opacity 0.2s',
  },
  '&:hover .edit-icon, &:hover .menu-icon': {
    opacity: 1,
  },
}));

export const CardContent = styled(Box)<{ selected: boolean }>(({ theme, selected }) => ({
  flex: 1,
  padding: '8px',
  borderRadius: '6px',
  backgroundColor: selected ? theme.palette.secondary.main : theme.palette.background.paper,
  border: `1px solid ${selected ? theme.palette.secondary.main : theme.palette.divider}`,
  display: 'flex',
  flexDirection: 'column',
  minWidth: 0,
  maxWidth: '100%',
  cursor: 'pointer',
  '&:hover': {
    border: `1px solid ${theme.palette.secondary.main}`,
  },
  '& span': {
    color: selected ? 'white' : theme.palette.text.secondary,
  },
  '.thumbnail-container': {
    backgroundColor: selected ? 'rgba(255, 255, 255, 0.25)' : 'transparent',
  },
}));
